export default "__VITE_ASSET__CWr2zp9R__"